<template>
  <div id="app">
    <el-container class="service-page-qiangzhi-buxudong">
      <meta name="viewport" content="width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=no">
      <el-main class="service-main">
        <div style="background: #FFFFFF;padding: 15px 25px;margin-top: 30px;">
          <el-row :gutter="10" style="text-align: center">
            <el-col :xs="8" :sm="6" :md="4" :lg="4" :xl="4" style="padding: 15px 0;">
              <div style="font-size: 16px">自定义分类:</div>
            </el-col>
            <el-col :xs="8" :sm="6" :md="4" :lg="4" :xl="4" style="padding: 15px 0;cursor: pointer;font-size: 14px;">
              <div @click="cate='',cate_xuanzhong='',list_data()">全部服务</div>
            </el-col>
            <el-col :xs="8" :sm="6" :md="4" :lg="4" :xl="4" style="padding: 15px 0;cursor: pointer;font-size: 14px;"
                    v-for="(item,index) in  data_serve" :key="index">
              <div><a @click="cate=item.value,cate_xuanzhong=item.value,list_data()"
                      :style="cate_xuanzhong==item.value?'color: #0c73db':''">{{ item.label }}</a></div>
            </el-col>
          </el-row>
        </div>
        <div class="service-head-background">
          <el-row>
            <el-col class="service-head-title" :xs="24" :sm="2" :md="2">综合</el-col>
            <el-col class="service-head-input" :xs="24" :sm="2" :md="3">
              <el-input
                      placeholder="请输入关键字"
                      v-model="input"
                      clearable>
              </el-input>
              <a @click="input_sj(input)" class="search-logo">
                <img src="../../../assets/home/sousuo_logo.png" alt="">
              </a>
            </el-col>
          </el-row>
        </div>
        <el-row :gutter="15">
          <el-col :xs="24" :sm="12" :md="6" v-for="(item,index) in fuwuzhi" v-bind:key="index">
            <a v-bind:href="'#/dianpu_details/'+ item.id">
              <div class="service-main-background">
                <el-image class="service-main-picture" :src="url+'/storage/'+item.cover" fit="cover">
                  <div slot="error" class="image-slot">
                    <img src="../../../assets/wenzhangfengmian.png" alt="">

                    <!--   <i class="el-icon-picture-outline"></i>-->
                  </div>
                </el-image>
                <div class="service-main-background-title" style="font-size: 12px">{{item.title}}</div>
              </div>
            </a>
          </el-col>
        </el-row>
        <div data-v-6af373ef="" data-v-5c2776a4="" class="pagination-container"
             style="line-height: 5.1em;margin-top: 60px">
          <div data-v-6af373ef="" class="el-pagination is-background" style="margin-left: -20px;margin-top: 40px">
            <span class="el-pagination__total">共 {{ zongshu }} 条</span>
            <el-pagination
                    style="float: left;margin-bottom: 150px"
                    layout="prev, pager, next"
                    @current-change="yedianji"
                    :total="yemashu*10">
            </el-pagination>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>

</template>
<script>
    export default {
        name: "category",

        data: function () {
            return {
                url: '',
                fuwuzhi: '',
                input: '',
                yemashu: '',
                zongshu: '',
                yemazhi: 1,
                searchValue: '',
                id: '',
                cate: '',
                cate_xuanzhong: '',
                data_serve: '',
                click: '',
                // businformation:''
            }
        },
        methods: {
            init() {
                var t = this;
                this.information = this.$store.state.information
                t.id = t.$route.params.id
                if (t.$store.state.shopsSearchValue) {
                    t.searchValue = t.$store.state.shopsSearchValue
                }
                if (t.searchValue) {
                    t.input = t.searchValue
                }
                this.list_data();
                this.url = window.config.api_url
                // this.dp_inform()
                this.fenlei()
            },
            fenlei() {
                var t = this
                var url = window.config.api_url + '/college/shop/fuwu/cate?shop_id=' + this.$route.params.id
                t.axios.get(url).then(res => {
                    // console.log(res)
                    t.data_serve = res.data
                })

            },
            yedianji(e) {
                this.yemazhi = e
                this.init()
                this.list_data(e)
            },
            list_data() {
                var t = this;
                // var url = window.config.api_url+'/college/fuwu/list?shop_id='+t.id
                var url = window.config.api_url + '/college/fuwu/list?shop_id=' + t.id + '&paginate=16'
                if (t.input) {
                    //url += ('&keywords='+'&title=')+t.input
                    url += '&title=' + t.input
                }
                if (t.yemazhi) {
                    url = url + '&page=' + t.yemazhi
                }

                if (t.checked === true) {
                    url += '&has_price=1'
                }
                if (t.cate) {
                    url += '&fuwu_cate=' + t.cate
                }
                t.axios.get(url).then(res => {
                    t.fuwuzhi = res.data.data
                    t.yemashu = res.data.last_page
                    t.zongshu = res.data.list?.total

                })
            },
            fujiaxz(e) {
                this.$router.push(this.url + '/storage/' + e);
            },
            handleChange2(e) {
                this.$store.commit('savePath', e)
            },
            input_sj() {
                var t = this
                t.list_data()
            }
        },
        created() {
            // this.$bus.$on('sentvalue', (data) => {
            //     this.businformation = data;
            //     console.log('我是create函数');
            //     console.log(this.businformation);
            //     console.log('我是回调函数里面的方法')
            //     console.log(this)
            // });
            // console.log('我是create里面的方法')
            // console.log(this.businformation);
            this.cate = this.$store.state.click;
            this.cate_xuanzhong = this.$store.state.click;
            this.init();
            console.log(this)
        },
        mounted() {

        }
    }
</script>
<style>
  .el-input__inner {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
  }

  .el-input--suffix .el-input__inner {
    border: 0px;
    width: 133px;
    height: 27px;
    background: #E1E1E1;
    border-radius: 5px;
  }
</style>
<style lang="less" scoped>
  @import "../../../../node_modules/element-ui/lib/theme-chalk/display.css";

  @head_text: Source Han Sans CN;
  // @font-face {

  // }

  //@import "../../../assets/css/home";
  @import "../../../assets/css/shops_service";
</style>
<style lang="less" scoped>
  // @font-face {

  // }
</style>
